import { sortAppointmentsByTimeAsc } from '.';

export default function getTuesdayAppointmets(appointments) {
    const filterTuesdayAppointments = appointments.filter(
        item => new Date(item.data.date).getDay() === 2,
    );
    return sortAppointmentsByTimeAsc(filterTuesdayAppointments);
}
